import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

class ImageComparator extends Component
{
    static propTypes = {
        imageLeft: PropTypes.object.isRequired,
        imageRight: PropTypes.object.isRequired,
        caption: PropTypes.string,
    }

    constructor(props)
    {
        super(props)

        this.separatorPosition = 50;

        this.state = { height: 0, width: 0, separatorPosition: 50 }
        this.onLoad = this.onLoad.bind(this)
        this.onInput = this.onInput.bind(this)
    }

    onInput(event)
    {

        this.setState({separatorPosition: event.target.value})
    }

    onLoad(event)
    {
        this.setState({
            height: event.target.naturalHeight,
            width: event.target.naturalWidth,
        })
    }

    render()
    {
        const { imageLeft, imageRight, caption } = this.props

        return (<figure className={"grid-12"}>
            <div className="o-image-comparator" style={{
                '--separatorPosition':`${this.state.separatorPosition}%`,
                '--h':this.state.height,
                '--w':this.state.width,
                'width':this.state.width
            }}>
                <img className="o-image-comparator__left" src={imageLeft.src} alt={imageLeft.alt} onLoad={this.onLoad}/>
                <img className="o-image-comparator__right" src={imageRight.src} alt={imageRight.alt}/>
                <input type="range" className="o-image-comparator__range" min="0" max="100" value={this.state.separatorPosition} onChange={this.onInput}/>
                <div className="o-image-comparator__range-selector">⟷</div>
            </div>
                {
                    caption && caption.length > 0 ? <figcaption className="col-12">{ caption }</figcaption> : null
                }
            </figure>
        )
    }
}

export default withTranslation()(ImageComparator)
